export default __webpack_public_path__ + "static/media/miss.e33fb122.mp4";